import { useTranslation } from "react-i18next";
import bg from '../../img/About/Funds/bg.jpg';
import image from '../../img/About/Funds/image.png';

const Funds = () => {
    const { t } = useTranslation();
    return (
        <section className="relative open-sans">
            <img className="absolute z-0 w-[100%] h-[100%] object-cover object-center inset-0" src={bg} alt='' />
            <div className="relative z-10 max-w-[1220px] xl:mx-auto mx-[20px] md:py-[60px] py-[50px]">
                <div className="md:grid items-center flex flex-col grid-cols-2 gap-0 md:gap-[40px] xl:gap-[95px]">
                    <div>
                        <h2 className="text-[#0C2780] font-[700] text-[28px] xl:text-[45px]">
                            {t('about.funds.title')}
                        </h2>
                        <div className="sm:text-[16px] text-[14px] text-[#0C2780] font-[300] mt-[25px] md:mt-[30px]">
                            <p>
                                {t('about.funds.text_01')}
                            </p>
                            <p className="mt-[13px] md:mt-[15px]">
                                {t('about.funds.text_02')}
                            </p>
                        </div>
                    </div>
                    <div className="flex justify-center items-center md:mt-0 mt-[45px]">
                        <img className="w-[100%] md:max-w-[465px] sm:max-w-[340px] max-w-[256px]" src={image} alt='' />
                    </div>
                </div>
            </div>
        </section>
    )
};

export default Funds;
